import $ from 'jquery';
import './Pagination';

$('.joboffers').each(function () {
    new Pagination($(this), '.joboffers__offer', 12)
})